export default "__VITE_ASSET__DX13SFCB__"